/**
 * Created by piotr.pozniak@thebeaverhead.com on 13/10/2018.
 */

const initialState = {
  collection: [],
  topMatchesCollection: [],
  locations: [],

  fetch: false,
  fetchError: null,
  fetchSuccess: null,

  page: 1,
  totalRows: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "EVENTS_FETCH":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: null,
      };

    case "EVENTS_FETCH_FULFILLED":
    case "EVENTS_FETCH_FULFILLED_CACHED":
      const events = action.preservePreviousEvents
        ? state.collection.concat(action.payload.events)
        : action.payload.events;

      return {
        ...state,
        collection: events,
        topMatchesCollection:
          action.payload.topMatches || state.topMatchesCollection,
        locations: action.payload.locations,
        page: action.payload.pagination ? action.payload.pagination.page : 0,
        totalRows: action.payload.pagination
          ? action.payload.pagination.count
          : events.length,
        fetch: false,
        fetchSuccess: true,
        fetchError: false,
      };

    case "EVENTS_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: true,
        collection: action.preservePreviousEvents ? state.collection : [],
        topMatchesCollection: action.preservePreviousEvents
          ? state.topMatchesCollection
          : [],
      };

    case "FEATURED_EVENTS_FETCH_FULFILLED":
    case "FEATURED_EVENTS_FETCH_FULFILLED_CACHED":
      if (state.collection.length) {
        const featuredCollection = state.collection.map((i) => ({
          ...i,
          is_featured:
            action.payload.events.findIndex((j) => j.id === i.id) >= 0,
        }));

        return {
          ...state,
          collection: featuredCollection,
        };
      }

      return state;

    case "EVENTS_COLLECTION_RESET":
      return {
        ...initialState,
      };

    default:
      return state;
  }

  return state;
}
